import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state): boolean | UrlTree | Observable<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const isLogged = authService.isLogged$.value;

  const targetIsDeclarations = state.url.startsWith('/declarations');
  const targetIsRoot = state.url === '' || state.url === '/';

  if (isLogged === true) {
    return  true ;
  }
  if (isLogged === false) {
    return targetIsRoot ? true : router.createUrlTree(['/']);
  }

  // CAS 2 : valeur pas encore connue => attendre une emission puis décider (take(1) pour éviter boucle)
  return authService.isLogged$.pipe(
    take(1),
    map(val => {
      if (val === true) {
        return targetIsDeclarations ? true : router.createUrlTree(['/declarations']);
      } else {
        return targetIsRoot ? true : router.createUrlTree(['/']);
      }
    })
  );
};
